import { cn } from "~/common/cn"
import { ResponsiveImage } from "~/content/responsive-image"
import { testimonials, type TestimonialId } from "~/content/testimonials"

const Attribution = ({ id, className }: { id: TestimonialId; className?: string }) => {
  const testimonial = testimonials[id]
  return (
    <figcaption className={cn("flex items-center gap-4", className)}>
      {"avatar" in testimonial ? (
        <ResponsiveImage
          assetId={testimonial.avatar}
          alt=""
          sizes="avatar"
          className="size-12 shrink-0 rounded-full object-cover"
        />
      ) : null}
      <span className="text-left">
        <span className="block font-semibold">{testimonial.name}</span>
        <span className="block text-sm text-muted-foreground">{testimonial.role}</span>
      </span>
    </figcaption>
  )
}

export const TestimonialQuote = ({ id }: { id: TestimonialId }) => (
  <section className="testimonial-quote container py-14 sm:py-20">
    <figure className="mx-auto max-w-4xl">
      <div aria-hidden="true" className="flex items-center gap-6">
        <span className="h-px flex-1 bg-secondary/20" />
        <span className="h-10 text-7xl font-bold leading-none text-primary">“</span>
        <span className="h-px flex-1 bg-secondary/20" />
      </div>
      <blockquote className="mt-5 text-balance text-center text-2xl leading-snug sm:text-3xl">
        {testimonials[id].quote}
      </blockquote>
      <Attribution id={id} className="mt-8 justify-center" />
    </figure>
  </section>
)
